import { AuthStore } from "../../../common/src/stores/AuthStore";
import { injectable } from "inversify";
import { UserEditFavoriteStore } from "../stores/user/UserEditFavoriteStore";
import analyticMap from "../molecules/industry-analytics/analyticMap";

@injectable()
export class AnalyticFavoriteManager {
    constructor(
        private readonly authStore: AuthStore,
        private readonly userEditFavoriteStore: UserEditFavoriteStore,
    ) {}

    getAnalyticId(componentName: string) {
        return (
            Object.keys(analyticMap).find((key) => analyticMap[key].component === componentName) ||
            null
        );
    }

    isFavorite(componentName: string | undefined) {
        if (!componentName) {
            return false;
        }
        const analyticId = this.getAnalyticId(componentName);
        return !!this.authStore.user?.favorites?.analytics?.find(
            (analytic) => analytic.analyticId === analyticId,
        );
    }

    async toggleFavorite(componentName: string | undefined): Promise<void> {
        if (!componentName) {
            return;
        }
        const analyticId = this.getAnalyticId(componentName);
        if (!analyticId) {
            return;
        }

        if (this.isFavorite(componentName)) {
            const indexOf =
                this.authStore.user?.favorites!.analytics?.findIndex(
                    (analytic) => analytic.analyticId === analyticId,
                ) || -1;
            if (indexOf >= 0) {
                this.authStore.user?.favorites?.analytics?.splice(indexOf, 1);
            }
            await this.userEditFavoriteStore.removeAnalytic(analyticId);
        } else {
            await this.userEditFavoriteStore.addAnalytic(analyticId);
        }
        await this.authStore.me();
    }
}
